import _ from 'lodash'
import moment from 'moment'
import genreSingleSelector from '@/components/genre_single_selector'
import sampleLicenseDialog from './components/sample_license_dialog'
import trackUploader from '@/components/trackuploader'
import contentTopHeader from '@/components/contentTopHeader'
import BannerUpload from '../BannerUpload'

import MeService from '@/services/me'
import AlbumService from '@/services/album'
import UserService from '@/services/user'
import ProductService from '@/services/product'
import ProfileService from '@/services/profile'
import { CollaboratorRoleTypes } from '@/helper'
import IconImage from '../../assets/music-sound.svg'
import BannerImage from '../../assets/album-drop.gif'
import uploadNav from './components/nav.vue'

export default {
  components: {
    genreSingleSelector,
    sampleLicenseDialog,
    trackUploader,
    contentTopHeader,
    BannerUpload,
    uploadNav
  },

  data() {
    return {
    activeTab: 'music',
    loading: false,
    iconImage: IconImage,
    bannerImage: BannerImage,
    majorDropdown: false,
    keyDropdown: false,
    majorValue:"none",
    keyValue:"none",
    keyOptions:[
      "C",
      "C#",
      "D",
      "Eb",
      "E",
      "F",
      "F#",
      "G",
      "Ab",
      "A",
      "Bb",
      "B",
    ],
    tabs: [
      { id: 'upload', title: 'Upload', isParent: true, path: 'UploadIndex' },
      { id: 'music', title: 'Music', path: 'UploadAlbum' },
      { id: 'video', title: 'Video', path: 'VideoUpload' },
      { id: 'product', title: 'Product', path: 'AddProduct' },
      { id: 'live', title: 'Broadcast Live', path: 'CreateLive' },
    ],
      isNeededToRelease: false,
      genres: [],
      products: [],
      selected_product: null,
      album: {
        name: '',
        released_at: null,
        location: '',
        genres: '',
        description: '',
        is_only_for_live_stream: false,
        is_content_acapella: false,
        is_content_instrumental: false,
        is_content_stems: false,
        is_content_remix: false,
        is_content_dj_mix: false,
        enabled_sample: 'false',
        image: null,
        cover: null,
        tracks: [],
        slug: null,
        user: {},
        bpm: '',
        access_level: [],
        download_price: 1,
      },
      album_image_url: null,
      locations: [],
      followings: [],
      users: [],
      potential_collaborators: [],
      potential_contributors: [],
      collaborators: [],
      contributors: [],
      samplings: [],
      artists: [],
      sampling_min_id: 0,
      page_index: 1,
      total_pages: 1,
      items_per_page: 30,
      show_genre_selector_dialog: false,
      show_sample_clearance_license_modal: false,
      isPageReady: false,
      albumUrl: null,
      access_levels: [],
      slug: null
    }
  },

  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser() {
      return this.$store.state.auth.user
    },

    isAvailableToUploadAlbum() {
      // console.log('isAvailableToUploadAlbum', this.album.tracks)
      const failed_track = _.find(
        this.album.tracks,
        (track) => track.status != 2
      )
      const has_failed_track = !!failed_track
      let bpmLevelGood = false
      if (this.album.bpm == '' || (this.album.bpm >= 1 && this.album.bpm <= 999)) {
        bpmLevelGood = true
      }
      let isSamplingsGood = true
      let sampling_track_id = 0
      let sample_track_id = 0
      let sample_album_id = 0
      let sample_user_id = 0
      for (let i = 0; i < this.samplings.length; i++) {
        sampling_track_id = _.get(this.samplings[i], 'sampling_track_id', 0)
        sample_track_id = _.get(this.samplings[i], 'sample_track_id', 0)
        sample_album_id = _.get(
          this.samplings[i],
          'sample_album_id.id',
          this.samplings[i].sample_album_id
        )
        sample_user_id = _.get(
          this.samplings[i],
          'sample_user_id.id',
          this.samplings[i].sample_user_id
        )
        // console.log(i, sampling_track_id, sample_track_id, sample_album_id, sample_user_id)
        if (
          !(
            sampling_track_id > 0 &&
            sample_track_id > 0 &&
            sample_album_id > 0 &&
            sample_user_id > 0
          )
        ) {
          isSamplingsGood = false
          break
        }
      }

      return (
        isSamplingsGood &&
        this.album.tracks.length > 0 &&
        !has_failed_track &&
        this.album.name.length &&
        this.album.image &&
        ((this.album.tracks.length > 1 && this.album.download_price >= 1 && this.album.download_price <= 1000) || this.album.tracks.length == 1) &&
        this.$store.state.genreSelector.genres.length > 0 &&
        bpmLevelGood
      )
    },

    isAvailableToEditAlbum() {
      // console.log('isAvailableToUploadAlbum', this.album.tracks)
      const failed_track = _.find(
        this.album.tracks,
        (track) => track.status !== 2
      )
      const has_failed_track = !!failed_track
      let isSamplingsGood = true
      let sampling_track_id = 0
      let sample_track_id = 0
      let sample_album_id = 0
      let sample_user_id = 0
      let bpmLevelGood = false
      if (this.album.bpm == '' || (this.album.bpm >= 1 && this.album.bpm <= 999)) {
        bpmLevelGood = true
      }
      for (let i = 0; i < this.samplings.length; i++) {
        sampling_track_id = _.get(this.samplings[i], 'sampling_track_id', 0)
        sample_track_id = _.get(this.samplings[i], 'sample_track_id', 0)
        sample_album_id = _.get(
          this.samplings[i],
          'sample_album_id.id',
          this.samplings[i].sample_album_id
        )
        sample_user_id = _.get(
          this.samplings[i],
          'sample_user_id.id',
          this.samplings[i].sample_user_id
        )
        // console.log(i, sampling_track_id, sample_track_id, sample_album_id, sample_user_id)
        if (
          !(
            sampling_track_id > 0 &&
            sample_track_id > 0 &&
            sample_album_id > 0 &&
            sample_user_id > 0
          )
        ) {
          isSamplingsGood = false
          break
        }
      }
      return (
        isSamplingsGood &&
        this.album.tracks.length > 0 &&
        !has_failed_track &&
        this.album.name.length &&
        this.album_image_url &&
        this.$store.state.genreSelector.genres.length > 0 &&
        bpmLevelGood
      )
    },

    role_types() {
      return CollaboratorRoleTypes
    },
  },

  created() {
    if (this.onMobile) {
      this.$router.push({name: "UploadIndex"})
    }

    const slug = this.$route.params.slug

    this.$store.dispatch('navigator/goNextState', { page: 'upload', tab: '' })
    if (this.currentUser && (this.currentUser.user_type === 'artist' || this.currentUser.user_type === 'brand')) {

      // check if its edit mode or create mode
      if (slug) {
        const vm = this
        this.isPageReady = false
        this.$store.dispatch('error/showLoadingActivity', true)
        this.slug = this.$route.params.slug
        Promise.all([
          // UserService.searchUsers(params)
          ProductService.getProducts({
            statuses: 'published, collaborated',
            stock_statuses: 'active',
            user_statuses: 'accepted',
          }),
          AlbumService.getAlbum(this.slug),
          MeService.mutualUsers({
            per_page: -1,
          }),
          ProfileService.getItems(this.currentUser.id, 'sample_followings', {
            per_page: -1,
          }),
        ])
          .then((values) => {
            this.genres = _.flatMap(this.$store.state.app.genres, 'children')
            this.products = values[0].body

            this.potential_collaborators = _.cloneDeep(values[2].body.users)
            this.potential_contributors = _.cloneDeep(values[2].body.users)
            this.potential_contributors.unshift(this.currentUser)
            this.artists = values[3].body.users

            this.album = values[1].body
            this.majorValue = this.album.bpm_key
            this.keyValue = this.album.bpm_value
            this.album_image_url = this.album.cover.url
            if (this.album.released_at) {
              this.album.released_at = moment(this.album.released_at).format(
                'YYYY-MM-DD'
              )
            } else {
              this.album.released_at = moment().format('YYYY-MM-DD')
            }
            this.album.enabled_sample = this.album.enabled_sample.toString()

            this.$store.dispatch('genreSelector/setGenres', this.album.genres)
            if (this.album.products.length > 0) {
              this.selected_product = this.album.products[0].id
            }
            if (this.album.collaborators.length > 0) {
              this.collaborators = this.album.collaborators
            }
            if (this.album.contributors.length > 0) {
              this.contributors = this.album.contributors
            }
            if (this.album.samplings.length > 0) {
              this.samplings = this.album.samplings
              _.each(this.samplings, (sampling) => {
                let artists = _.cloneDeep(this.artists)
                _.each(artists, (u) => {
                  u.sampling_id = sampling.id
                })
                sampling.artists = artists
              })

              let users_ids = _.chain(this.samplings)
                .map('sample_user_id')
                .uniq()
                .value()
              let fns = _.map(users_ids, (user_id) =>
                AlbumService.getAlbums({
                  statuses: 'published, collaborated',
                  user_statuses: 'accepted',
                  user_id: user_id,
                  enabled_sample: true,
                })
              )
              Promise.all(fns).then((values) => {
                for (let i = 0; i < values.length; i++) {
                  let samplings = _.filter(
                    this.samplings,
                    (s) => s.sample_user_id === users_ids[i]
                  )
                  _.each(samplings, (sampling) => {
                    let albums = values[i].body
                    _.each(albums, (a) => {
                      a.sampling_id = sampling.id
                    })
                    sampling.artist_albums = albums
                    sampling.artist_album_tracks = _.find(
                      albums,
                      (a) => a.id === sampling.sample_album_id
                    ).tracks
                    // console.log('samplings', this.samplings)
                  })
                }

                this.isPageReady = true
                this.$store.dispatch('error/showLoadingActivity', false)
              })
            } else {
              this.isPageReady = true
              this.$store.dispatch('error/showLoadingActivity', false)
            }
            // console.log('album_edit created', this.users)
            setTimeout(function () {
              $('#album_image').css(
                'background-image',
                'url(' + vm.album.cover.url + ')'
              )
            }, 200)
          })
          .catch((reason) => {
            console.log(reason)
            this.$store.dispatch('error/showLoadingActivity', false)
            this.$store.dispatch('error/showErrorToast', reason)
            // this.isPageReady = true
          }) 
      } else {
        this.album.released_at = moment().format('YYYY-MM-DD')
        this.isPageReady = false
        this.$store.dispatch('error/showLoadingActivity', true)
        Promise.all([
          // UserService.searchUsers(params),
          ProductService.getProducts({
            statuses: 'published, collaborated',
            stock_statuses: 'active',
            user_statuses: 'accepted',
          }),

          MeService.mutualUsers({
            per_page: -1,
          }),
          ProfileService.getItems(this.currentUser.id, 'sample_followings', {
            per_page: -1,
          }),
        ])
          .then((values) => {
            this.products = values[0].body
            this.$store.dispatch('genreSelector/setGenres', [])
  
            this.genres = _.flatMap(this.$store.state.app.genres, 'children')
  
            // this.followings = _.cloneDeep(values[1].body.users)
            // this.users = _.cloneDeep(values[1].body.users)
            // this.users.unshift(this.currentUser)
            // // this.artists = _.filter(this.followings, (user) => (user.user_type === 'artist'))
            // this.artists = _.cloneDeep(values[2].body.users)
  
            this.potential_collaborators = _.cloneDeep(values[1].body.users)
            this.potential_contributors = _.cloneDeep(values[1].body.users)
            this.potential_contributors.unshift(this.currentUser)
            this.artists = values[2].body.users
  
            this.isPageReady = true
            this.$store.dispatch('error/showLoadingActivity', false)
          })
          .catch((reason) => {
            // console.log(reason)
            this.$store.dispatch('error/showLoadingActivity', false)
            this.$store.dispatch('error/showErrorToast', reason)
          })
      }
    } else {
      this.$router.push({ path: '/' })
    }
  },

  methods: {
    setKeyValue(value){
      this.keyValue = value;
    },
    onCopy: function (e) {
      this.$store.dispatch("error/showSuccessToast", [
        "You just copied: " + e.text,
      ]);
      // alert('You just copied: ' + e.text)
    },

    onError: function (e) {
      this.$store.dispatch("error/showErrorToast", ["Failed to copy link"]);
      // alert('Failed to copy link')
    },

    isUploaded(){
      if(this.isUpload){
        this.isUpload = false;
      }
      else{
        this.isUpload =true;
      }
    },
    isActiveTab(tab) {
      return this.activeTab === tab
    },
    onTab(tab) {
      if (tab.path) {
        this.$router.push({name: tab.path})
      }
    },
    imageChanged(e) {
      this.album.image = e.target.files[0]
      var reader = new FileReader()
      reader.addEventListener(
        'load',
        (event) => {
          this.album_image_url = event.target.result
        },
        false
      )
      reader.readAsDataURL(this.album.image)
    },

    deleteMerch(item) {
      console.log('deleted')
    },

    learnMore() {},

    addCollaborator() {
      this.collaborators.push({
        user_id: '',
        user_role: '',
      })
    },

    deleteCollaborator(index) {
      this.collaborators.splice(index, 1)
    },

    addContributor() {
      this.contributors.push({
        user_id: '',
        user_role: '',
      })
    },

    deleteContributor(index) {
      this.contributors.splice(index, 1)
    },

    addSampling() {
      this.sampling_min_id -= 1
      let sampling = {
        id: this.sampling_min_id,
        sampling_track_id: '',
        sample_track_id: '',
        sample_album_id: '',
        sample_user_id: '',
      }
      let artists = _.cloneDeep(this.artists)
      _.each(artists, (u) => {
        u.sampling_id = sampling.id
      })
      sampling.artists = artists
      this.samplings.push(sampling)
    },

    deleteSampling(index) {
      this.samplings.splice(index, 1)
    },

    onChangeSampleArtist(user) {
      // console.log('onChangeSampleArtist', user.sampling_id, user.id, user.display_name)
      AlbumService.getAlbums({
        statuses: 'published, collaborated',
        user_statuses: 'accepted',
        user_id: user.id,
        enabled_sample: true,
      }).then((response) => {
        let sampling = _.find(this.samplings, (s) => s.id == user.sampling_id)
        let albums = response.body
        _.each(albums, (a) => {
          a.sampling_id = user.sampling_id
        })
        sampling.artist_albums = albums
        sampling.artist_album_tracks = []
        sampling.sample_album_id = 0
        sampling.sample_track_id = 0
        this.$forceUpdate()
      })
    },

    onChangeSampleArtistAlbum(album) {
      // console.log('onChangeSampleArtistAlbum', album.sampling_id, album.name)
      let sampling = _.find(this.samplings, (s) => s.id == album.sampling_id)
      sampling.artist_album_tracks = album.tracks
      sampling.sample_track_id = 0
      this.$forceUpdate()
    },

    deleteAlbum() {
      const id = ''
      this.isLoading = true
      AlbumService.deleteAlbum(id)
        .then((response) => {
          this.isLoading = false
          this.$router.push({ path: '/album' })
        })
        .catch((e) => {
          this.isLoading = false
          this.errorMessage = e.body.errors[0].detail
          this.showError = true
        })
    },

    saveForLater() {
      this.uploadAlbum()
    },

    openGenreSelectorDialog() {
      this.show_genre_selector_dialog = true
    },

    closeGenreSelectorDialog() {
      this.show_genre_selector_dialog = false
    },

    openSampleClearanceLicenseModal() {
      this.show_sample_clearance_license_modal = true
    },

    closeSampleClearanceLicenseModal() {
      this.show_sample_clearance_license_modal = false
    },

    releaseNow() {
      if (this.collaborators.length == 0) {
        this.isNeededToRelease = true
      }
      this.uploadAlbum()
    },

    uploadAlbum() {
      this.loading = true
      this.$store.dispatch('error/showLoadingActivity', true)
      var tracks = []
      for (let index in this.album.tracks) {
        const track = this.album.tracks[index].track
        if (track) {
          tracks.push(track.id)
        }
      }

      const track_ids = tracks.join(',')
      const genre_ids = this.$store.getters['genreSelector/genre'].id
      const formData = new FormData()
      formData.append('album[name]', this.album.name)
      formData.append('album[description]', this.album.description)
      formData.append('album[released_at]', this.album.released_at)
      formData.append('album[location]', this.album.location || '')
      formData.append('album[bpm]', this.album.bpm)
      formData.append('album[access_level]', this.album.access_level)
      formData.append('album[download_price]',
        this.album.tracks.length > 1 ? this.album.download_price : this.album.tracks[0].download_price
      )
      if (this.majorValue !== 'none') {
        formData.append('album[bpm_key]', this.majorValue)
        formData.append('album[bpm_value]', this.keyValue)
      }

      formData.append(
        'album[is_only_for_live_stream]',
        this.album.is_only_for_live_stream
      )
      formData.append(
        'album[is_content_acapella]',
        this.album.is_content_acapella
      )
      formData.append(
        'album[is_content_instrumental]',
        this.album.is_content_instrumental
      )
      formData.append('album[is_content_stems]', this.album.is_content_stems)
      formData.append('album[is_content_remix]', this.album.is_content_remix)
      formData.append('album[is_content_dj_mix]', this.album.is_content_dj_mix)
      formData.append(
        'album[enabled_sample]',
        this.album.enabled_sample === 'true'
      )
      formData.append('album[cover]', this.album.image)
      formData.append('album[track_ids]', track_ids)
      formData.append('album[genre_ids]', genre_ids)
      // #TODO pass null when no selection
      formData.append('album[product_ids]', this.selected_product)
      formData.append(
        'album[collaborators]',
        JSON.stringify(this.collaborators)
      )
      formData.append('album[contributors]', JSON.stringify(this.contributors))

      let samplings = []
      _.each(this.samplings, (sampling) => {
        let s = {
          sampling_track_id: sampling.sampling_track_id,
          sample_track_id: sampling.sample_track_id,
          sample_album_id: _.get(
            sampling,
            'sample_album_id.id',
            sampling.sample_album_id
          ),
          sample_user_id: _.get(
            sampling,
            'sample_user_id.id',
            sampling.sample_user_id
          ),
        }
        samplings.push(s)
      })
      // console.log('samplings', samplings)
      formData.append('album[samplings]', JSON.stringify(samplings))

      AlbumService.createAlbum(formData)
        .then((response) => {
          if (this.isNeededToRelease) {
            this.album = response.body
            this.albumURL = window.location.origin + "/album/" + this.album.slug
            this.releaseAlbum(response.body.id)
          } else {
            this.loading = false
            this.$store.dispatch('error/showLoadingActivity', false)
            if (this.collaborators.length > 0) {
              this.$store.dispatch('navigator/setParams', {
                album_id: response.body.id,
              })
              this.$router.push({ path: '/album/' + response.body.id })
            } else {
              this.$router.push({ path: '/albums' })
            }
          }
        })
        .catch((e) => {
          this.loading = false
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },

    releaseAlbum(album_id) {
      AlbumService.releaseAlbum(album_id)
        .then((response) => {
          this.loading = false
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch('navigator/setParams', { album_id: album_id })
          if (album_id) {
            localStorage.setItem("release_album", album_id)
            this.$router.push({path: '/album/' + album_id})
          }
        })
        .catch((e) => {
          this.loading = false
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },

    repostAlbum(album_id) {
      AlbumService.repostAlbum(album_id)
        .then((response) => {
          this.$store.dispatch('error/showLoadingActivity', false)
          // this.$router.push({ path: '/album' })
        })
        .catch((e) => {
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },
  },

  mounted() {
    const vm = this
    $.getJSON('../../static/cities.json', function (data) {
      vm.locations = data
    })
    UserService.getAccessLevels(this.currentUser.id)
      .then((response) => {
        this.access_levels = response.body
        this.album.access_level.push('published')
      })
      .catch((e) => {
        this.$store.dispatch(
          'error/showErrorToast',
          e.body.errors || [e.body]
        )
      })
  },
}



// WEBPACK FOOTER //
// ./src/views/album/upload_album.ctrl.js